var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5257C6.98625 25.5257 1.6875 20.2269 1.6875 13.7132C1.6875 7.19945 6.98625 1.9007 13.5 1.9007C20.0138 1.9007 25.3125 7.19945 25.3125 13.7132C25.3125 20.2269 20.0138 25.5257 13.5 25.5257ZM13.5 3.5882C7.91438 3.5882 3.375 8.12757 3.375 13.7132C3.375 19.2988 7.91438 23.8382 13.5 23.8382C19.0856 23.8382 23.625 19.2988 23.625 13.7132C23.625 8.12757 19.0856 3.5882 13.5 3.5882Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.9319C16.7231 17.9319 16.5713 17.8982 16.4363 17.8138L12.2175 15.2826C12.0931 15.2069 11.9905 15.1002 11.9195 14.9731C11.8485 14.8459 11.8117 14.7026 11.8125 14.5569V7.80695C11.8125 7.33445 12.1838 6.9632 12.6563 6.9632C13.1288 6.9632 13.5 7.33445 13.5 7.80695V14.0844L17.3138 16.3626C17.4708 16.4588 17.5923 16.6037 17.6596 16.7752C17.7269 16.9467 17.7365 17.1355 17.6869 17.3129C17.6373 17.4904 17.5312 17.6468 17.3847 17.7585C17.2382 17.8702 17.0593 17.9311 16.875 17.9319Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.04d5ab133b53b9db09420f9ffb2244cf.svg";
export { ForwardRef as ReactComponent };